import React, { useEffect, useState, memo } from 'react';
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import Logo from '../../Assets/Images/SingIn/Logo.png';
import './style'

import apiAdonis from '../../Services/adonis';
import './style.css'

import { Container, Form } from './style';
import viewModel from './viewModel';
import { Objeto } from "../../Services/Models";

const View: React.FC<viewModel> = (viewModel) => {
    const [getUser, setUser] = useState();

    useEffect(() => {
        async function componentDidMount() {
            const urlParams = new URLSearchParams(window.location.search)
            const token = urlParams.get('token')
            await apiAdonis.put(`/usuarios/${token}`, { status_user: true }).then(results => {
                setUser(results.data.username)
            })
        }
        componentDidMount();
    }, []);

    return (
        <Container>
            <Form>
                <img style={{ marginBottom: "20px" }} src={Logo} />
                <h2 style={{ fontFamily: "StarJedi1" }}>Analytics</h2>
                <h6>O acesso do usuário {getUser} foi aprovado!</h6>
            </Form>
        </Container>
    );
    /* #endregion */
};

export default View;